var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getTranslation } from '../../../../utils/translations';
import translations from './translations';
import { currencyInputUtils } from '../../../../utils/currencyInput.utils';
import { CALCULATOR_DECISIONS } from './formModel.types';
var t = getTranslation(translations);
function makeFormulaLabel(a, b) {
    var aTitle = currencyInputUtils.numberToString(Math.ceil(a));
    var bTitle = currencyInputUtils.numberToString(Math.ceil(b));
    var sumTitle = currencyInputUtils.numberToString(Math.ceil(a + b));
    return "".concat(aTitle, "\u20AC + ").concat(bTitle, "\u20AC = ").concat(sumTitle, "\u20AC");
}
function makeDecisionDescription(title, a, b) {
    return "".concat(title, "\n").concat(makeFormulaLabel(a, b));
}
function makeLabelFromAmountTemplate(template, value) {
    var underfundingLabel = "".concat(currencyInputUtils.numberToString(value), "\u20AC");
    return template.replace('%amount%', underfundingLabel);
}
export var helpers = {
    getUnderfundingValueToShow: function (underfunding) {
        return Math.max(underfunding || 0, 0);
    },
    getUnderfundingWithBrokersFee: function (data, isBrokerFeePresented) {
        // @todo: Manage case if value is less than zero with no broker's service usage
        return isBrokerFeePresented
            ? data.underfunding
            : data.underfunding - data.brokerFee;
    },
    getDerivedData: function (data, derivedUnderfunding, isBrokerFeePresented, decision) {
        var nextData = __assign({}, data);
        if (!isBrokerFeePresented) {
            nextData.brokerFee = 0;
        }
        nextData.underfunding = derivedUnderfunding;
        switch (decision) {
            case CALCULATOR_DECISIONS.ADD_UNDERFUNDING_TO_LOAN_AMOUNT:
                nextData.loanAmount = Math.ceil(nextData.loanAmount + derivedUnderfunding);
                nextData.underfunding = 0;
                return nextData;
            case CALCULATOR_DECISIONS.ADD_UNDERFUNDING_TO_AVAILABLE_EQUITY:
                nextData.availableEquity = Math.ceil(nextData.availableEquity + derivedUnderfunding);
                nextData.underfunding = 0;
                return nextData;
            case CALCULATOR_DECISIONS.NEED_ADVICE:
            default:
                return nextData;
        }
    },
    getDerivedDataCortege: function (data, isBrokerFeePresented, decision) {
        var derivedUnderfunding = helpers.getUnderfundingWithBrokersFee(data, isBrokerFeePresented);
        var derivedData = helpers.getDerivedData(data, derivedUnderfunding, isBrokerFeePresented, decision);
        return [derivedData, derivedUnderfunding];
    },
    makeDecisionOptions: function (loanAmount, availableEquity, derivedUnderfunding) {
        derivedUnderfunding =
            helpers.getUnderfundingValueToShow(derivedUnderfunding);
        return [
            {
                value: CALCULATOR_DECISIONS.ADD_UNDERFUNDING_TO_LOAN_AMOUNT,
                label: makeLabelFromAmountTemplate(t.decisionOption_addToLoanAmount, derivedUnderfunding),
                description: makeDecisionDescription(t.decisionOptionDescription_addToLoanAmount, loanAmount, derivedUnderfunding),
            },
            {
                value: CALCULATOR_DECISIONS.ADD_UNDERFUNDING_TO_AVAILABLE_EQUITY,
                label: makeLabelFromAmountTemplate(t.decisionOption_addToAvailableEquity, derivedUnderfunding),
                description: makeDecisionDescription(t.decisionOptionDescription_addToAvailableEquity, availableEquity, derivedUnderfunding),
            },
            {
                value: CALCULATOR_DECISIONS.NEED_ADVICE,
                label: t.decisionOption_needAdvice,
                description: t.decisionOptionDescription_needAdvice,
            },
        ];
    },
    makeCheckoutTableRows: function (data) {
        return [
            { title: t.purchasePriceRow, value: data.purchasePrice },
            { title: t.notaryFeeRow, value: data.notaryFee, module: '+' },
            { title: t.taxRow, value: data.tax, module: '+' },
            { title: t.brokerFeeRow, value: data.brokerFee, module: '+' },
            { title: t.additionalCostRow, value: data.additionalCost, module: '+' },
            { title: t.availableEquityRow, value: data.availableEquity, module: '–' },
            { title: t.loanAmountRow, value: data.loanAmount, module: '–' },
        ].filter(function (_a) {
            var value = _a.value;
            return typeof value === 'number';
        });
    },
};
export default helpers;
